import ListItem from "./index";

function LearninResourceListItem({ data, ...props }) {
  return (
    <ListItem
      {...props}
      itemId={data.id}
      type="card"
      className="bccampus-material-info-card"
      href={`/resource/${data.code}/`}
      aria-label={`${data.type.name}: ${data.name}`}
      coverImage={data.image}
      title={data.name}
      extra={data.course ? `For ${data.course}` : undefined}
      meta={<span>{data.type.name}</span>}
    />
  );
}

export default LearninResourceListItem;
